import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Chip, Tooltip } from "@mui/material";
import RemisionStateHistoryUI from "./RemisionStateHistoryUI";
import { remisionService } from "@services/RemisionService";
import { createHeader, formatDate, REMISION_STATE_CHIP } from "@utils/utils";
import { IStateChange } from "src/types/global";
const rowsPerPage = 10;
const RemisionStateHistory = () => {
  const {
    id
  } = useParams();
  const [stateChanges, setStateChanges] = useState<IStateChange[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const getStateHistory = useCallback(async (remisionId: number) => {
    try {
      setIsLoading(true);
      const res = await remisionService.getStateHistory(remisionId);
      setStateChanges(res.data);
    } catch {
      setStateChanges([]);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    if (!id) return;
    getStateHistory(Number(id));
  }, [id, getStateHistory]);
  const pages = Math.max(1, Math.ceil(stateChanges.length / rowsPerPage));
  const rows = stateChanges.slice(rowsPerPage * (currentPage - 1), rowsPerPage * currentPage).map(change => ({
    changedAt: formatDate(change.changedAt),
    toState: <Tooltip title={change.fromState ? `Desde: ${change.fromState}` : "Estado inicial"} placement="top">
          <Chip color={REMISION_STATE_CHIP[change.toState]?.color ?? "default"} label={REMISION_STATE_CHIP[change.toState]?.label ?? change.toState} />
        </Tooltip>,
    employeeName: change.employeeName ?? "—"
  }));
  const headers = [createHeader("Fecha", "changedAt"), createHeader("Estado", "toState"), createHeader("Cambiado por", "employeeName")];
  return <RemisionStateHistoryUI title="Historial de estados" headers={headers} rows={rows} pages={pages} isLoading={isLoading} onChangePage={setCurrentPage} emptyMessage="Sin cambios de estado registrados" />;
};
export default RemisionStateHistory;